import React, { FC, ReactElement, useContext } from 'react';

import {
    OrganizationTreasury,
    OrganizationProposals,
    OrganizationVoters,
    OrganizationProCoalitions,
    OrganizationResearch,
    TabsController,
} from './components';

import {
    TREASURY,
    PROPOSALS,
    MEMBERS,
    COALITIONS,
    RESEARCH,
    DELEGATES,
    VOTER_TRENDS,
    TOKEN,
    VOTER_DECENTRALIZATION,
    EXECUTIVE_SUMMARY,
} from 'constants/organizationTabs';

import { OrganizationContext } from 'context/organizationContext';
import { OrganizationDelegates } from './components/OrganizationDelegates';
import { OrganizationVoterTrends } from './components/OrganizationVoterTrends';
import { OrganizationToken } from './components/OrganizationToken';
import { OrganizationCoalitions } from './components/OrganizationCoalitions';
import { OrganizationExecutiveSummary } from './components/OrganizationExecutiveSummary';
import { useAppSelector } from '../../../../store';
import { OrganizationFinance } from './components/OrganizationFinance';
import { OrganizationVoterDecentralization } from './components/OrganizationVoterDecentralization';

export const OrganizationData: FC = (): ReactElement => {
    const { organizationDataTabSelected } = useContext(OrganizationContext);

    const { organizationTabs } = useAppSelector(({ organizationTabs }) => organizationTabs);
    const { premiumUserData } = useAppSelector(({ premiumSubscription }) => premiumSubscription);
    const {
        organizationData: { isDefaultPremium, isInTop100 },
    } = useAppSelector(({ organization }) => organization);
    const isCoalitionsProTab = organizationTabs.data.find((t) => t.tab.name === COALITIONS);
    const isPremiumAllowed = Boolean(isDefaultPremium || premiumUserData?.isPremiumAllowed);

    // const treasuryTab = isTreasuryProTab && isPremiumAllowed ? <OrganizationTreasury /> : <OrganizationFinance />;
    // TODO: check if we need to show finance tab for non-pro users
    const treasuryTab = isInTop100 ? <OrganizationTreasury isPremiumAllowed={isPremiumAllowed} /> : <OrganizationFinance />;
    const coalitionsTab =
        isCoalitionsProTab && isPremiumAllowed ? <OrganizationProCoalitions /> : <OrganizationCoalitions isInTop100={isInTop100} isPremiumAllowed={isPremiumAllowed} />;

    const renderOrganizationDataComponent = () => {
        switch (organizationDataTabSelected) {
            case EXECUTIVE_SUMMARY:
                return <OrganizationExecutiveSummary isPremiumAllowed={isPremiumAllowed} />;

            case TREASURY:
                return treasuryTab;

            case TOKEN:
                return <OrganizationToken isPremiumAllowed={isPremiumAllowed} />;

            case PROPOSALS:
                return <OrganizationProposals />;

            case MEMBERS:
                return <OrganizationVoters />;

            case COALITIONS:
                return coalitionsTab;

            case RESEARCH:
                return <OrganizationResearch />;

            case DELEGATES:
                return <OrganizationDelegates isPremiumAllowed={isPremiumAllowed} />;

            case VOTER_DECENTRALIZATION:
                return <OrganizationVoterDecentralization />;

            case VOTER_TRENDS:
                return <OrganizationVoterTrends isPremiumAllowed={isPremiumAllowed} />;

            default:
                return treasuryTab;
        }
    };

    return (
        <>
            <TabsController isInTop100={isInTop100} />
            {renderOrganizationDataComponent()}
        </>
    );
};
